import { compose, branch, renderComponent } from 'recompose'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import withEventListener from 'components/common/hoc/withEventListener'
import { getLocationPathname } from 'selectors/getPageLocation'
import { getCurrentStore, getPageLocation } from 'selectors'
import isHomePage from 'helpers/isHomePage'
import isBlackFridayPage from 'helpers/isBlackFridayPage'
import isMyGaragePage from 'helpers/isMyGaragePage'
import { STORE_LOCATOR_MODAL_PAGE, LOCATION_PAGE } from 'constant'
import { showStoreLocatorModal } from 'actions/storeLocator'
import PromotionResultList from './PromotionResultList'
import PromotionSlider from '../PromotionSlider'
import withPromotionTileResize from './../withPromotionTileResize'

const mapStateToProps = state => {
  const location = getPageLocation(state)
  const isLocationPage = location.pathname.startsWith(LOCATION_PAGE)

  return {
    isHomePage: isHomePage(getLocationPathname(state)),
    isMyGaragePage: isMyGaragePage(getLocationPathname(state)),
    isBlackFridayPage: isBlackFridayPage(getLocationPathname(state)),
    isLocationPage,
    hasStore: Boolean(getCurrentStore(state))
  }
}

const withGlobalEventHandler = withEventListener({
  eventName: STORE_LOCATOR_MODAL_PAGE,
  getHandler: ({ showStoreLocatorModal }) => () => showStoreLocatorModal()
})

const withPromoSlider = branch(({ isHomePage, isMyGaragePage, isLocationPage }) =>
  isHomePage || isMyGaragePage || isLocationPage, renderComponent(PromotionSlider))

export default compose(
  withType({ type: ['PromotionResultList', 'PromotionResultListMyGarage']}),
  connect(mapStateToProps, { showStoreLocatorModal }),
  withPromotionTileResize,
  withGlobalEventHandler,
  withPromoSlider
)(PromotionResultList)
